"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var LoadingTextBase_1 = __importDefault(require("./LoadingTextBase"));
var LoadingContentWrapper = (0, material_1.styled)('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  width: 100%;\n  pointer-events: none;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  position: fixed;\n  width: 100%;\n  pointer-events: none;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var LoadingContent = function () { return ((0, jsx_runtime_1.jsx)(LoadingContentWrapper, { children: (0, jsx_runtime_1.jsx)(LoadingTextBase_1.default, {}) })); };
exports.default = LoadingContent;
var templateObject_1;
